const getIsDataNotLoaded = error => {
  const nonFieldErrors = error?.response?.data?.non_field_errors || [];
  const haveDataNotLoaded = nonFieldErrors.find(item => item.code === "data_not_loaded");
  return !!haveDataNotLoaded;
};

export { getIsDataNotLoaded };
